import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { useOfferDefinitionsApiClient } from '@/api/clients/useOfferDefinitionsApiClient.util.ts';
import { OfferDefinitionDto, OfferDefinitionsSearchResponseDto } from '@/api/generated';
import { QueryKeyEnum } from '@/api/model/QueryKey.enum.ts';

// ponytail: single-page fetch capped at 100 active definitions; add server-side
// search-as-you-type if the catalog ever outgrows one page.
const PAGE_SIZE = 100;

type Return = {
  /** Active definitions with their components, to pick the ones that can receive a dictionary entry. */
  definitions: OfferDefinitionDto[];
  isError: boolean;
  isLoading: boolean;
};

/** Active offer definitions for the create dialog; fetched only once a rezerwacja wstępna is possible. */
export const useGetCreateOfferDefinitions = (enabled: boolean): Return => {
  const { offerDefinitionsApi } = useOfferDefinitionsApiClient();

  const { data, isError, isLoading } = useQuery<OfferDefinitionsSearchResponseDto, AxiosError>({
    enabled,
    queryFn: async () => {
      const { data } = await offerDefinitionsApi.searchOfferDefinitions(0, PAGE_SIZE, {
        active: true,
      });
      return data;
    },
    queryKey: [QueryKeyEnum.PROCESS.CREATE_OFFER_DEFINITIONS],
  });

  return { definitions: data?.items ?? [], isError, isLoading };
};
